<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19DIwmb/tc-custom/9781440515064.jpg?1718106016586" alt="This image is the cover for the book Only Psychic Power Book You'll Ever Need"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Only Psychic Power Book You'll Ever Need
      </h1>
      <p class="bookDescription body article font2">
        <p>This is an easy-to-follow guide to explain the meaning behind “being psychic” and the different levels of ability, and demonstrates how to use these skills responsibly.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael R. Hathaway
      </h2>
      
      <p class="authorDescription body article">An Adams Media author.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Adams Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8703ce10